<template >
  <component v-if="level !== 'h7' && level !== 'h8'" :is="level" :class="['heading', light ? 'light' : 'dark']">
    <slot/>
  </component>
    <p v-else-if="level === 'h7' || level === 'h8'" :class="['heading', level, light ? 'light' : 'dark']">
    <slot/>
  </p>
</template>

<script>
/**
 * Headings are used as the titles of each major section of a page in the
 * interface. For example, templates generally use headings as their title.
 * Heading element provides an option to change the level of the heading.
 */
export default {
  name: 'AppHeading',
  status: 'prototype',
  release: '1.0.0',
  props: {
    /**
     * The heading level used for the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    level: {
      type: String,
      default: 'h1',
      validator: value => {
        return value.match(/(h1|h2|h3|h4|h5|h6|h7|h8)/)
      }
    },
    light: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";

.heading {
  @include reset;
  @include stack-space($space-m);
  font-family: $font-heading;
  line-height: $line-height-xs;
  color: $color-purple-darker;
  @media #{$media-query-l} {
    // This is how you’d use design tokens with media queries
  }
  small {
    font-size: 0.6em;
  }
}
.heading.light {
  color: $color-white;
}
h1 {
  letter-spacing: $spacing-xs;
  font-size: $size-xxxl;
  font-weight: $weight-bold;
  @media #{$media-query-l} {
    font-size: $size-xxxl;
  }
}
h2 {
  letter-spacing: $spacing-s;
  font-size: $size-xxl;
  font-weight: $weight-bold;
}
h3 {
  font-size: $size-xl;
  font-weight: $weight-bold;
}
h4 {
  font-size: $size-l;
  font-weight: $weight-semi-bold;
}
h5 {
  font-size: $size-m;
  font-weight: $weight-semi-bold;
}
h6 {
  font-size: $size-s;
  font-weight: $weight-normal;
}
p.h7 {
  font-size: $size-xs;
  font-weight: $weight-normal;
}
p.h8 {
  font-size: $size-xxs;
  font-weight: $weight-normal;
}
</style>
